(function () {
  var MONTHS_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var CONFETTI_SRC = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js';

  function loadConfettiLib(callback) {
    if (window.confetti) {
      callback();
      return;
    }
    var existing = document.querySelector('script[data-confetti-lib]');
    if (existing) {
      existing.addEventListener('load', callback, { once: true });
      return;
    }
    var script = document.createElement('script');
    script.src = CONFETTI_SRC;
    script.async = true;
    script.dataset.confettiLib = 'true';
    script.addEventListener('load', callback, { once: true });
    document.head.appendChild(script);
  }

  function fireConfetti() {
    var alreadyFired;
    try {
      alreadyFired = sessionStorage.getItem('confetti_fired');
    } catch (e) {
      alreadyFired = null;
    }
    if (alreadyFired) return;
    try {
      sessionStorage.setItem('confetti_fired', 'true');
    } catch (e) {}

    loadConfettiLib(function () {
      if (typeof window.confetti !== 'function') return;
      window.confetti({
        particleCount: 80,
        spread: 70,
        origin: { y: 0.3 },
        colors: ['#000000', '#333333', '#666666', '#999999', '#cccccc'],
        scalar: 0.8
      });
    });
  }

  // Reads "now" in Europe/Madrid and returns a UTC-anchored Date holding those
  // wall-clock parts, so all date maths below are timezone-independent.
  function madridNow() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Madrid',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
    var obj = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      obj[p.type] = p.value;
    });
    return new Date(
      Date.UTC(
        parseInt(obj.year, 10),
        parseInt(obj.month, 10) - 1,
        parseInt(obj.day, 10),
        parseInt(obj.hour, 10),
        parseInt(obj.minute, 10)
      )
    );
  }

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function nextBusinessDay(date) {
    var result = new Date(date.getTime());
    do {
      result.setUTCDate(result.getUTCDate() + 1);
    } while (isWeekend(result));
    return result;
  }

  // Dispatch day: today when it's a weekday before 12:00 Madrid time,
  // otherwise the next business day. Delivery is the following business day,
  // with a 2-day window (so it never lands on a weekend and never stretches
  // beyond 2 days of margin).
  function computeDates() {
    var now = madridNow();
    var dispatch;

    if (!isWeekend(now) && now.getUTCHours() < 12) {
      dispatch = new Date(now.getTime());
    } else {
      dispatch = nextBusinessDay(now);
    }

    var receiveStart = nextBusinessDay(dispatch);
    var receiveEnd = nextBusinessDay(receiveStart);

    return { order: now, dispatch: dispatch, receiveStart: receiveStart, receiveEnd: receiveEnd };
  }

  function formatDate(date) {
    return MONTHS_ES[date.getUTCMonth()] + ' ' + date.getUTCDate();
  }

  function formatRange(start, end) {
    if (start.getUTCMonth() === end.getUTCMonth()) {
      return MONTHS_ES[start.getUTCMonth()] + ' ' + start.getUTCDate() + ' - ' + end.getUTCDate();
    }
    return formatDate(start) + ' - ' + formatDate(end);
  }

  function populate(container) {
    if (container.dataset.shippingPopulated === 'true') return;
    container.dataset.shippingPopulated = 'true';

    var dates = computeDates();

    var orderEl = container.querySelector('[data-shipping-step="order"]');
    var prepareEl = container.querySelector('[data-shipping-step="prepare"]');
    var receiveEl = container.querySelector('[data-shipping-step="receive"]');

    if (orderEl) orderEl.textContent = formatDate(dates.order);
    if (prepareEl) prepareEl.textContent = formatDate(dates.dispatch);
    if (receiveEl) receiveEl.textContent = formatRange(dates.receiveStart, dates.receiveEnd);

    setTimeout(fireConfetti, 900);
  }

  function populateAll() {
    document.querySelectorAll('[data-cart-shipping-timeline]').forEach(populate);
  }

  function init() {
    populateAll();
    var target = document.getElementById('CartDrawer') || document.body;
    new MutationObserver(populateAll).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
